const $inject = ['$q', '$http', '$rootScope'];

const dataService = function ($q, $http, $rootScope) {
    let service = {
        data: {
            activeItem: undefined,
            items: []
        },
        addNewMode: false,
        addNewBackup: undefined,
        cleanDataOnRouteChange: false,
        refreshDataOnLoad: false,
        get,
        post,
        spiltDataAt
    };

    service.search = function search(endpoint, searchTerm, searchType, expression, optionalParameters = {}) {
        let optionalDefaultParameters = {
            includeDeleted: true,
            isMultiSelect: false,
            includeDisabled: true,
            filterUsingEnabled: false,
            queryOption: "filter",
            selectProperty: ""
        }
        optionalParameters = Object.assign({}, optionalDefaultParameters, optionalParameters);
        const isSelectQueryOption = optionalParameters.queryOption === "select" && !!optionalParameters.selectProperty;
        let deferred = $q.defer();
        let type = searchType || 'Id';
        let qs = '';
        expression = expression || 'eq';

        if(optionalParameters.queryOption === "filter"){
            if (expression === 'contains') {
                let searchTermToLower = searchTerm.toLowerCase().trim();
    
                expression = `contains(tolower(${type}), '${searchTermToLower}')`;
            } else {
                if(optionalParameters.isMultiSelect){
                    let expressionArray = [];
                    searchTerm.forEach(term => expressionArray.push(`${type} eq '${term}'`));
                    expression = expressionArray. length > 1 ? `(${expressionArray.join(" or ")})`: expressionArray;
                }else{
                    expression = `${type} eq '${searchTerm}'`;
                }            
            }
    
            if (searchTerm) {
                qs = `${endPointUrl}/odata/${endpoint}?$filter=${expression}`;
            } else {
                qs = `${endPointUrl}/odata/${endpoint}`;
            }
        }

        if(isSelectQueryOption){
            qs += `${endPointUrl}/odata/${endpoint}?$select=${optionalParameters.selectProperty}`;
        }

        if (!optionalParameters.includeDeleted) {
            if (qs.indexOf('$filter') === -1) {
                qs += `?$filter=&IsDeleted ne true`;
            } else {
                qs += ` and IsDeleted ne true`;
            }
        }

        if (!optionalParameters.includeDisabled) {
            if (qs.indexOf('$filter') === -1) {
                qs += `?$filter=&${(optionalParameters.filterUsingEnabled ? "Enabled" : "Disabled")} eq ${(optionalParameters.filterUsingEnabled ? "true" : "false")}`;
            } else {
                qs += ` and ${(optionalParameters.filterUsingEnabled ? "Enabled" : "Disabled")} eq ${(optionalParameters.filterUsingEnabled ? "true" : "false")}`;
            }
        }

        $http.get(qs)
            .success(function (data) {
                console.log(data);

                let responseData = data.value || data;

                if(isSelectQueryOption){
                    responseData = data[`${optionalParameters.selectProperty}`]
                }

                deferred.resolve(responseData);
            })

            .error(function (err, x) {
                console.log(err, x);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    function get(query, id, isRestEndpoint) {
        $rootScope.$broadcast('lbaLoader:loaderState', { state: true });

        let deferred = $q.defer();
        let restClientType = isRestEndpoint ? 'api' : 'odata';
        const url = id ? `${endPointUrl}/${restClientType}/${query}('${id}')` : `${endPointUrl}/${restClientType}/${query}`;

        $http.get(url)
            .success(function (data, status, headers) {
                const ETag = headers('ETag');
                if (ETag) {
                    sessionStorage.setItem('ETag', ETag);
                }
                $rootScope.$broadcast('lbaLoader:loaderState', { state: false, text: '' });
                $rootScope.$broadcast('lbaToast:showToast', { message: 'Data fetched', messageType: 'success' });

                let responseData = data.value || data;

                deferred.resolve(responseData);
            })
            .error(function (err, x) {
                console.log(err, x);
                deferred.reject(err);
            });

        return deferred.promise;
    }

    function post(query, data, noETag) {
        let deferred = $q.defer();
        const url = `${endPointUrl}/odata/${query}`;
        const settings = {};
        if (!noETag) {
            settings.headers = {
                'If-Match': sessionStorage.getItem('ETag')
            }
        }
        $rootScope.$broadcast('lbaToast:showToast', { message: 'Posting data...', messageType: 'waiting' });

        $http.post(url, data, settings)
            .success(function (data, status, headers) {
                $rootScope.isSaved = true;
                const ETag = headers('ETag');
                if (ETag) {
                    sessionStorage.setItem('ETag', ETag);
                }
                $rootScope.$broadcast('lbaToast:showToast', { message: 'Data saved', messageType: 'success' });
                deferred.resolve(data);
            })
            .error(function (data, status) {
                console.error(data);
                if (status === 412) {
                    $rootScope.$broadcast('lbaToast:showToast', { message: 'Data out of date - please refresh', messageType: 'error' });
                } else if (status === 400) {
                    $rootScope.$broadcast('lbaToast:showToast', { message: `Provided data is not valid - please review the data`, messageType: 'error' });
                } else {
                    $rootScope.$broadcast('lbaToast:showToast', { message: 'Error occurred', messageType: 'error' });
                }

                deferred.reject();
            });

        return deferred.promise;
    };

    function spiltDataAt(dataAt, routeParams) {
        return dataAt.split('.').map(x => {
            if (x.startsWith('$')) {
                x = routeParams[x.substring(1)]
            }
            return x;
        });
    }

    service.delete = function deleteId(resource, id) {
        let deferred = $q.defer();

        $http.delete(`${endPointUrl}/odata/${resource}('${id}')`)
            .success(data => {
                deferred.resolve(data);
            })
            .error(data => {
                deferred.reject(data);
            });


        return deferred.promise;
    };

    service.patch = function patchResource(resource, data, id, noETag) {
        let deferred = $q.defer();

        const settings = {};
        if (!noETag) {
            settings.headers = {
                'If-Match': sessionStorage.getItem('ETag')
            }
        }
        $rootScope.$broadcast('lbaToast:showToast', { message: 'Updating data...', messageType: 'waiting' });

         if (!noETag) {
            settings.headers = {
                'If-Match': sessionStorage.getItem('ETag')
            }
        }
        $http.patch(`${endPointUrl}/odata/${resource}('${id}')`, data, settings)
            .success((data, status, headers) => {
                $rootScope.isSaved = true;
                const ETag = headers('ETag');
                if (ETag) {
                    sessionStorage.setItem('ETag', ETag);
                }
                $rootScope.$broadcast('lbaToast:showToast', { message: 'Data saved', messageType: 'success' });
                deferred.resolve(data);
            })
            .error((data, status) => {
                console.error(data);
                if (status === 412) {
                    $rootScope.$broadcast('lbaToast:showToast', { message: 'Data out of date - please refresh', messageType: 'error' });
                } else if (status === 400) {
                    $rootScope.$broadcast('lbaToast:showToast', { message: `Provided data is not valid - please review the data`, messageType: 'error' });
                } else {
                    $rootScope.$broadcast('lbaToast:showToast', { message: 'Error occurred', messageType: 'error' });
                }
                deferred.reject(data);
            });


        return deferred.promise;
    };

    return service;
};

dataService.$inject = $inject;

export default dataService;


// WEBPACK FOOTER //
// ./src/services/dataService.js